import * as React from "react";
import { useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Input } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { BiChevronDown } from "react-icons/bi";
import { DownOutlined } from "@ant-design/icons";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
      //   width: 250,
      width: "90%",
      margin: "1px auto",
    //   marginLeft: "13px",
    },
  },
};

const useStyles = makeStyles((theme) => ({

  icon: {
    //   position:"relative",
    right: 10,
    // border:"1px solid red",
    marginTop:"-5px"
  },

}));



export default function RecommendationFilter({
  interestsArray,
  setInterestsArray,
  setRecommendations,
  initialRecommendation,
  recommendations
}) {
  // const [d, setInterestsArray] = React.useState([]);

   const classes = useStyles();

  const applyFilter = () => {
    const newFilter = initialRecommendation.filter((item) =>
      interestsArray.includes(item.id)
    );
    if (newFilter.length > 0) setRecommendations(newFilter);
    else setRecommendations(initialRecommendation);
  };

  useEffect(() => {
    applyFilter();
  }, [interestsArray, initialRecommendation]);

  const handleChange = (e) => {
    const loInterestsArray = [...interestsArray];
    if (interestsArray.includes(e.target.value[0])) {
      loInterestsArray.forEach((item, i) => {
        if (item === e.target.value[0]) {
          loInterestsArray.splice(i, 1);
          return;
        }
      });
      setInterestsArray(loInterestsArray);
    } else {
      setInterestsArray([...interestsArray, e.target.value[0]]);
    }
  };

  const selectedBrandsLabel=()=>{
    return  `${recommendations.map((item) => item.name )[0] }${recommendations.length>1?` +${recommendations.length-1} more`:""}` 
    
    }

  return (
    <div
      style={{
        // boxShadow: "0px 0px 34px rgba(174, 174, 174, 0.25)",
        borderRadius: "5px",
        margin: "10px auto",
        marginBottom: "10px",
        width: " 90%",
        background: "#fff",
        border: "0.5px solid #000000",
      }}
    >
      {/* <button
        onClick={applyFilter}
        // disabled={interestsArray.length>0? false : true}

        style={{
          background: interestsArray.length > 0 ? "#6C63FF" : "#D0D0D0",
          border: "none",
          color: "white",
          padding: 12.5,
          borderRadius: 5,
          margin: "10px auto",
          width: "90%",
          marginTop: "22.5px",
          position: "sticky",
          bottom: 0,
          marginLeft: "15px",
        }}
      >
        Apply
      </button> */}
      <FormControl
        style={{
          width: "100%",
        }}
        //   sx={{ m: 0, width: "100%", paddingLeft: "10px" }}
      >
        <InputLabel
          style={{
            // zIndex: -10,
            zIndex: 0,
            marginLeft: "5px",
            fontSize: "16px",
            color: interestsArray.length===0?"#151414":"#6C63FF",
            fontWeight: "500",
          }}
          shrink={false}
        >
     {interestsArray.length===0?  "All Categories" :selectedBrandsLabel()   }
        </InputLabel>
        <Select
          multiple
          value={[]}
          onChange={handleChange}
          input={<Input style={{}} />}
          //   renderValue={true}
          MenuProps={MenuProps}
          disableUnderline={true}
          style={{
            marginLeft: "8px",
            // marginTop: interestsArray.length > 0 ? "5px" : "20px",
          }}
          classes={{
            icon: classes.icon,
            // iconOpen: classes.iconOpen,
            // select: classes.selectSelect,
          }}
          //   IconComponent={() => (
          //     <BiChevronDown
          //       style={{
          //         border: "1px solid red",
          //         marginTop: "-20px",
          //         marginRight: "10px",
          //         fontSize: "30px",
          //          pointerEvents:"all"
          //       }}
          //       // color="disabled"
          //     />
          //   )}
        >
          <p
            style={{
              fontWeight: "600",
              paddingLeft: "15px",
              fontSize: "16px",
            }}
          >
            Select categories
          </p>
          {initialRecommendation.map((item) => (
            <MenuItem value={item.id} key={item.id}>
              <ListItemText primary={item.name} />
              <Checkbox
                checked={interestsArray.includes(item.id) ? true : false}
              />
            </MenuItem>
          ))}

          {/* {console.log("interestsArray", interestsArray)} */}
        </Select>
      </FormControl>
    </div>
  );
}
